import React, { Component } from 'react'
import Slider from "react-slick";
import { NavLink } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './style.scss'

class HeroSlider extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            arrows: true,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 8000,
        };
        return (
            <Slider className={this.props.className} {...settings}>
                {this.props.sliders.map((slider, i) => (
                    <div
                        key={i}
                        className={`slideWrapper ${slider.images}`}
                    >
                        <div
                            className="sliderContent">
                            <div className="container">
                                <div className="row">
                                    <div className="col col-lg-8" style={{ backgroundColor: 'rgba(39,44,63,0.8)', padding: '2rem' }}>
                                        <p>{slider.text}</p>
                                        <h2><span className='hero-text'>{slider.title}</span> <span>{slider.subTitle}</span></h2>
                                        <div className="btnStyle btnStyle3">
                                            <NavLink exact to='/contact'>{slider.button}</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        )
    }
}
export default HeroSlider